module.exports = __webpack_public_path__ + "assets/img/image-02.a9261405.png";